import fly from 'flyio'
import { FlyRequestConfig } from 'flyio'

interface IProtocol<T> {
    code: number,
    msg: string,
    data: T
}

class Http {
    public static get<T = any, R = any>(url: string, data?: T, config?: FlyRequestConfig): Promise<IProtocol<R>> {
        return fly.get<IProtocol<R>>(url, data, config).then(res => res.data)
    }

    public static post<T = any, R = any>(url: string, data?: T, config?: FlyRequestConfig): Promise<IProtocol<R>> {
        return fly.post(url, data, config).then(res => res.data)
    }

    public static jsonToForm(json: object): string {
        const str = []
        for (const p in json) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(json[p]))
        }
        return str.join("&")
    }
}

export {
    Http
}


// WEBPACK FOOTER //
// ./src/utils/http.ts